<template>
  <p class="m-0">
    <a-tooltip v-if="cellProps" :title="cellProps.remark">
      <a-tag>{{ cellProps.message_type }}</a-tag>
      <br />
      <small>
        {{
          cellProps.hdn_creation_date | toDate(DateFormatEnum.DISPLAY_DATETIME)
        }}
      </small>
    </a-tooltip>
  </p>
</template>

<script>
import { DateFormatEnum } from "~/enums";

export default {
  props: {
    cellProps: {
      type: Object,
    },
  },
  data() {
    return {
      DateFormatEnum,
    };
  },
};
</script>

<style scoped></style>
